// CSV import + sample download helpers.
import { parseDMY } from "./dateUtils";

const SAMPLE_CSV = `ulazak,izlazak
01.01.2025,15.01.2025
10.03.2025,25.03.2025
20.05.2025,05.06.2025
01.10.2025,
`;

const triggerDownload = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

export const downloadCSVSample = () => {
  const blob = new Blob([SAMPLE_CSV], { type: "text/csv;charset=utf-8" });
  triggerDownload(blob, "schengen_primjer.csv");
};

/**
 * Parses a CSV of trips with columns "ulazak,izlazak" (dates in DD.MM.YYYY).
 * A header row is auto-detected. Empty exit column = open trip.
 * Rows with unparseable entry are skipped (reported).
 */
export const importCSV = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      try {
        const text = String(reader.result || "").replace(/^\uFEFF/, "");
        const lines = text.split(/\r?\n/).map((l) => l.trim()).filter(Boolean);
        if (lines.length === 0) {
          reject(new Error("CSV datoteka je prazna"));
          return;
        }
        const startIdx = /ulazak|entry/i.test(lines[0]) ? 1 : 0;
        const trips = [];
        let skipped = 0;
        for (let i = startIdx; i < lines.length; i++) {
          const parts = lines[i].split(/[,;\t]/).map((p) => p.trim());
          const entryIso = parseDMY(parts[0]);
          if (!entryIso) {
            skipped++;
            continue;
          }
          const exitIso = parts[1] ? parseDMY(parts[1]) : null;
          trips.push({
            id: `csv_${Date.now().toString(36)}_${i}_${Math.random()
              .toString(36)
              .slice(2, 6)}`,
            entry: entryIso,
            exit: exitIso,
          });
        }
        if (trips.length === 0) {
          reject(
            new Error(
              "Nijedan red nije uspješno parsiran. Provjerite format DD.MM.GGGG.",
            ),
          );
          return;
        }
        resolve({ trips, skipped });
      } catch (e) {
        reject(e);
      }
    };
    reader.onerror = () => reject(reader.error);
    reader.readAsText(file);
  });
